import React from 'react'
import Hero from '../../components/Hero';
import Album from '../../components/Album';
import Videos from '../../components/Videos';
import Calendar from '../../components/Calendar';
import Footer from '../../components/Footer';
// import ShowBanner from '../../components/ShowBanner';
// import CentralD from '../../images/Central_D.jpg';
// import CentralJ from '../../images/Central_J.jpg';
// import CentralN from '../../images/Central_N.jpg';
// import CentralR from '../../images/Central_R.jpg';

const Home = () => {
    return (
        <div>
            <Hero />
            {/* <ShowBanner image={CentralD} /> */}
            <Album />
            {/* <ShowBanner image={CentralJ} /> */}
            <Videos />
            {/* <ShowBanner image={CentralN} /> */}
            <Calendar />
            {/* <ShowBanner image={CentralR} /> */}
            <Footer />
        </div>
    )
}

export default Home
